import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { logOut } from '../store/user';

const LayoutNav = styled.nav`
    background-color: ${ ({ theme }) => theme.colors.blue };
    height: 100%;
`

interface IUser {
    [x: string]: { idUser: any; email: any; id_ref: any; token: any; };
}

interface IState {
    user: IUser;
    status: string;
}

export const Nav = () => {
    const  { idUser: user } = useSelector((state: IState) => state.user.user);
  let navigate = useNavigate()
  const dispatch = useDispatch()

  const handleLogout = () => {
    dispatch(
      logOut()
    )
    navigate("/", { replace: true }) 
  }

  return (
    <LayoutNav className="navbar navbar-expand-lg navbar-dark">
      <div className="container-fluid mx-3">

        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarScroll" aria-controls="navbarScroll" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        
        <div className="collapse navbar-collapse" id="navbarScroll">
          <div className="d-flex">
            {user ? 
              <button onClick={handleLogout} className="btn btn-info" type="button">Salir</button>
              :  
              ""
            }
          </div>
        </div>
      </div>
    </LayoutNav>
  )
}